<template>
    <div>
        <htmlHeader :top_index="0" :menuCode="false" :crumbsShow="true" />

        <div style="width: 1200px; margin: auto; padding-bottom: 10%; overflow: hidden">
            <userLeft :active="14" />
            <div class="box5">
                <div style="overflow: hidden">
                    <div class="box6" style="float: left">发票管理</div>
                </div>
                <div class="box7"></div>
                <div class="base_box">
                    <div style="overflow: hidden">
                        <div class="base_box_title">增值税普通发票</div>
                        <router-link :to="pupiao ? '/add_pupiao?uuid=' + pupiao.uuid : '/add_pupiao'"
                            ><div class="base_box_right_txt">
                                {{ pupiao ? '修改信息' : '新增发票' }}
                            </div></router-link
                        >
                    </div>
                    <div style="overflow: hidden; margin-top: 2%">
                        <div v-if="!pupiao_show">
                            <div style="width: 50%; float: left" class="base_box_title">发票抬头：{{ pupiao.title }}</div>
                            <div style="width: 50%; float: left" class="base_box_title">统一社会信用代码：{{ pupiao.unifiedSocialCreditCode }}</div>
                        </div>
                        <div v-else>
                            <img src="../assets/zanwu1.png" style="width: 53px; height: 43px; display: block; margin: 20px auto;" alt="" />
                            <div style="text-align: center; margin-top: 20px;color: #999; font-size: 14px;">尚未添加增值税普通发票信息</div>
                        </div>
                    </div>
                </div>

                <div class="base_box">
                    <div style="overflow: hidden">
                        <div class="base_box_title">增值税专用发票</div>
                        <router-link :to="zhuanpiao ? '/add_zhuanpiao?uuid=' + zhuanpiao.uuid : '/add_zhuanpiao'"
                            ><div class="base_box_right_txt">
                                {{ zhuanpiao ? '修改信息' : '新增发票' }}
                            </div></router-link
                        >
                    </div>

                    <div v-if="!zhuanpiao_show">
                        <div style="overflow: hidden; margin-top: 2%">
                            <div style="width: 50%; float: left" class="base_box_title">公司名称：{{ zhuanpiao.title }}</div>
                            <div style="width: 50%; float: left" class="base_box_title">统一社会信用代码：{{ zhuanpiao.unifiedSocialCreditCode }}</div>
                        </div>
                        <div style="overflow: hidden; margin-top: 2%">
                            <div style="width: 50%; float: left" class="base_box_title">注册地址：{{ zhuanpiao.registerAddress }}</div>
                            <div style="width: 50%; float: left" class="base_box_title">注册电话：{{ zhuanpiao.registerTel }}</div>
                        </div>
                        <div style="overflow: hidden; margin-top: 2%">
                            <div style="width: 50%; float: left" class="base_box_title">开户银行：{{ zhuanpiao.bankName }}</div>
                            <div style="width: 50%; float: left" class="base_box_title">银行账号：{{ zhuanpiao.bankAccount }}</div>
                        </div>
                        <!-- <div style="overflow: hidden; margin-top: 4%">
                            <div style="float: left; margin-top: 40px" class="base_box_title">
                                证书扫描件
                            </div>
                            <div style="float: left; overflow: hidden; width: 80%">
                                <img v-if="item" :src="'/api/file/preview/' + item" style="width: 80px; height: 84px; float: left; margin-left: 2%" :key="index" v-for="(item, index) in zhuanpiao.scanList" alt="" />
                            </div>
                        </div> -->
                    </div>
                    <div v-else>
                        <img src="../assets/zanwu1.png" style="width: 53px; height: 43px; display: block; margin: 20px auto;" alt="" />
                        <div style="text-align: center; margin-top: 20px;color: #999; font-size: 14px;">尚未添加增值税专用发票</div>
                    </div>
                </div>

                <div class="base_box">
                    <div style="overflow: hidden">
                        <div class="base_box_title">发票接收方式</div>
                        <router-link to="/add_ticket_collection_method?id=0"><div class="base_box_right_txt">添加电子发票</div></router-link>
                        <router-link to="/add_ticket_collection_method?id=1"><div class="base_box_right_txt">添加纸质发票</div></router-link>
                    </div>
                    <div class="table_head_box">
                        <div style="width: 50%; height: 100%; float: left">
                            <a-row>
                                <a-col :span="8" class="table_head_txt">收票方式</a-col>
                                <a-col :span="8" class="table_head_txt">姓名</a-col>
                                <a-col :span="8" class="table_head_txt">手机</a-col>
                            </a-row>
                        </div>
                        <div style="width: 50%; height: 100%; float: left; text-align: left" class="table_head_txt">
                            收货地址
                        </div>
                    </div>
                    <div
                        :key="index"
                        v-for="(item, index) in user_invoice_receive"
                        class="table_head_box"
                        style="
              margin-top: 0;
              background: none;
              border-bottom: 1px solid #f4f4f4;
            "
                    >
                        <div style="width: 50%; height: 100%; float: left">
                            <a-row>
                                <a-col :span="8" class="table_head_txt">{{ item.types == 'PAPER' ? '纸质发票' : '电子发票' }}</a-col>
                                <a-col :span="8" class="table_head_txt">{{ item.name }}</a-col>
                                <a-col :span="8" class="table_head_txt">{{ item.mobile }}</a-col>
                            </a-row>
                        </div>
                        <div style="width: 50%; height: 100%; float: left; text-align: left" class="table_head_txt">
                            <div style="width: 50%; height: 100%; float: left">{{ item.address }}</div>
                            <div style="width: 50%; height: 100%; float: left">
                                <a-row>
                                    <a-col :span="12" class="table_head_txt moren_box" style="min-width: 104px;" v-if="item.defaults">默认{{ item.types == 'PAPER' ? '纸质发票' : '电子发票' }}</a-col>
                                    <a-col :span="12" @click="shezhimoren(item)" class="table_head_txt" style="color: #2c9a34; cursor: pointer;" v-else>设为默认{{ item.types == 'PAPER' ? '纸质发票' : '电子发票' }}</a-col>
                                    <a-col :span="6" class="table_head_txt" style="color: #2c9a34"><router-link :to="'/add_ticket_collection_method?uuid=' + item.uuid" style="color: #2c9a34;">编辑</router-link></a-col>
                                    <a-col @click="shanchu(item.uuid)" :span="6" class="table_head_txt" style="color: #2c9a34">删除</a-col>
                                </a-row>
                            </div>
                        </div>
                    </div>
                    <!-- <div v-if="user_invoice_receive.length == 0" style="text-align: center; margin-top: 20px;">没有记录~</div> -->
                    <div v-if="user_invoice_receive.length == 0">
                        <img src="../assets/zanwu1.png" style="width: 53px; height: 43px; display: block; margin: 20px auto;" alt="" />
                        <div style="text-align: center; margin-top: 20px;color: #999; font-size: 14px;">尚未添加发票接收方式</div>
                    </div>
                </div>
            </div>
        </div>
        <foot />
    </div>
</template>

<script>
import axios from 'axios';
import userLeft from '../public/user_left';
import htmlHeader from '../public/head';
import foot from '../public/foot';
export default {
    name: 'ControlOverInvoice',
    components: {
        userLeft,
        htmlHeader,
        foot
    },
    data() {
        return {
            user_invoice: null,
            pupiao: '',
            zhuanpiao: '',
            user_invoice_receive: [],
            pupiao_show: false,
            zhuanpiao_show: false
        };
    },
    methods: {
        // 设置默认
        shezhimoren(e) {
            const that = this;
            let obj = e;
            obj.defaults = true;
            that.$confirm({
                title: `设置为默认吗?`,
                onOk() {
                    that.api.add_user_invoice_receive(obj).then(res => {
                        if (res.ok) {
                            that.$message.success(res.message);
                            that.get_user_invoice_receive();
                        } else {
                            that.$message.error(res.message);
                        }
                    });
                }
            });
        },
        // 删除
        shanchu(e) {
            const that = this;
            that.$confirm({
                title: `确定删除吗?`,
                onOk() {
                    that.api.delete_user_invoice_receive(e).then(res => {
                        if (res.ok) {
                            that.$message.success(res.message);
                            that.get_user_invoice_receive();
                        } else {
                            that.$message.error(res.message);
                        }
                    });
                }
            });
        },
        // 获取我的发票接收方式列表
        get_user_invoice_receive() {
            this.api.get_user_invoice_receive().then(res => {
                if (res.ok) {
                    this.user_invoice_receive = res.data;
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        // 我的发票资料 专票和普票
        get_user_invoice() {
            this.api.get_user_invoice('GENERAL').then(res => {
                if (res.ok) {
                    if (res.data == null) {
                        this.pupiao_show = true;
                    }
                    this.pupiao = res.data;
                } else {
                    this.$message.error(res.message);
                }
            });

            this.api.get_user_invoice('DEDICATED').then(res => {
                if (res.ok) {
                    if (res.data == null) {
                        this.zhuanpiao_show = true;
                    }
                    this.zhuanpiao = res.data;
                } else {
                    this.$message.error(res.message);
                }
            });
        }
    },
    created() {
        this.get_user_invoice();
        this.get_user_invoice_receive();
        // this.api.jiachashiming().then((res) => {
        //     if (res.data.realName === false) {
        //     this.$message.error('即将跳转个人信息完成内容填写')
        //     setTimeout(() => {
        //       this.$router.push('/user_info')
        //     }, 1000)
        //   } else if (res.data.company === false) {
        //     this.$message.error('即将跳转企业信息完成内容填写')
        //     setTimeout(() => {
        //       this.$router.push('/enterprise_info')
        //     }, 1000)
        //   }
        // })
    }
};
</script>
<style scoped>
.moren_box {
    background: #f24246;
    color: #fff !important;
    width: 90px;
    height: 26px;
    background: #f24246;
    line-height: 26px !important;
    font-size: 13px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    margin-top: 10px !important;
}
.table_head_txt {
    font-size: 13px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #343434;
    text-align: center;
    line-height: 43px;
    cursor: pointer;
}
.table_head_box {
    overflow: hidden;
    margin-top: 2%;
    width: 100%;
    height: 43px;
    background: #f4f4f4;
}
.base_box_right_txt {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #2c9a34;
    float: right;
    margin: 0 0 0 20px;
}
.base_box_title {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #343434;
    float: left;
}
.base_box {
    width: 100%;
    padding: 2%;
    margin-top: 2%;
    border: 1px solid #ede9e9;
}
.box7 {
    width: 100%;
    height: 1px;
    border-top: 1px solid #e8e6e6;
    margin-top: 2%;
}

.box6 {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    /* margin-top: 2%; */
    text-align: left;
}

.box5 {
    width: 80%;
    min-height: 1023px;
    border: 1px solid #ede9e9;
    float: right;
    margin-top: 2%;
    padding: 2%;
}

.box3 {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: Regular;
    color: #666666;
    margin-top: 6%;
}

.box4 {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
}

.box1 {
    width: 220px;
    min-height: 1023px;
    border: 1px solid #ede9e9;
    float: left;
    margin-top: 2%;
}

.box2 {
    width: 100%;
    height: 45px;
    background: #f2f2f2;
}
</style>



// WEBPACK FOOTER //
// src/components/control_over_invoices.vue